<template>
  <form :id="'frm-'+id" class="px-3" method="post" onsubmit="return false">
    <div :aria-labelledby="id+'-title'"
         :data-id="name"
         :id="id"
         :data-backdrop="'static'"
         :data-keyboard="'false'"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled pb-0">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body overflow-x-hidden px-0 md:px-3">
            <div v-if="addingCoResearchers" class="mx-3 mt-3">
              <p class="alert alert-info">
                Para agregar coinvestigadores externos, favor de verificar que sea un correo vigente.
              </p>
            </div>
            <div>
              <div class="form-group px-3 py-2 m-0">
                <select type="text"
                        id="externalEmails"
                        ref="externalEmails"
                        name="externalEmails"
                        class="form-control"
                        placeholder="@"
                        multiple></select>
                <small class="form-text text-muted">
                  Ingrese el o los correos electrónicos separados por espacios, coma (,) o enter.
                </small>
                <button @click.prevent="sendInvitation"
                        class="btn btn-primary mt-3"
                        :disabled="sendingInvitation">
                  <span class="spinner-border text-yellow-500 spinner-border-sm"
                        role="status"
                        v-if="sendingInvitation">
                    <span class="sr-only">Guardando...</span>
                  </span>
                  Enviar invitación
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer flex justify-content-between px-2 shadow-none">
            <button class="btn btn-secondary ml-2" data-dismiss="modal" type="button">Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  
  export default {
    name: 'ExternalUsersModal',
    props: {
      title: {
        default: 'Seleccione un usuario externo',
      },
      id: {
        default: 'external-users-modal',
      },
      name: {
        default: 'external-users-modal',
      },
      addingCoResearchers: {
        type: Boolean,
        default: false,
      },
      amendment: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        sendingInvitation: false,
      }
    },
    methods: {
       ...mapActions({
        sendInvitationsByEmails: 'protocols/sendInvitationByEmail',
        sendAmendmentInvitationsByEmails: 'amendments/sendInvitationByEmail',
      }),
      ...mapMutations({
        setProtocolExternalResearchers: 'protocols/SET_PROTOCOL_EXTERNAL_RESEARCHERS',
        setProtocolResearchers: 'protocols/SET_PROTOCOL_RESEARCHERS',
      }),
      close() {
        $(this.$el).find('.modal').modal('hide')
      },
      async sendInvitation () {

        let emailsInput = $(this.$refs.externalEmails)

        const options = emailsInput.find('option')

        if (options.length > 0) {
          let formattedOptions = ''

          options.each(function() {
            formattedOptions += '<option value="'+this.innerText+'" selected="selected">'+this.innerText+'</option>'
          })

          emailsInput.html(formattedOptions).trigger('change')
        }

        if (emailsInput.val().length < 1) {
          AlertManager.error('Es necesario agregar por lo menos un correo electrónico.')

          return
        }

        this.sendingInvitation = true

        let emails = emailsInput.select2('data').map(email => email.text)

        emailsInput.prop("disabled", true)
        
        const response = this.amendment ?
          await this.sendAmendmentInvitationsByEmails({ amendment: this.amendment, emails }) :
          await this.sendInvitationsByEmails({ emails })
        
        const {
          status,
          message,
          error,
          external_researchers,
          researchers,
        } = response.data.data
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)

        emailsInput.val(null).html('').prop("disabled", false).trigger("change")

        this.setProtocolExternalResearchers(external_researchers)
        this.setProtocolResearchers(researchers)

        this.sendingInvitation = false
        
        this.$emit('invitations-sent')
      },
    },
    computed: {
      ...mapState(['user']),
      
      ...mapGetters({
        researchers: 'users/researchers',
        protocol: 'protocols/selectedProtocol',
      }),
    },
     mounted () {
      /**
       * Init Select2
       */
      const $emails = $('#externalEmails')

      function validateEmail(email) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        return regex.test(email);
      }
      
      $emails.select2({
        tags: true,
        tokenSeparators: [',', ' '],
        selectOnClose: true,
        createTag: function(term, data) {
          const value = term.term

          if(validateEmail(value)) {
            $('.select2-search__field').css('color', '#28a745')

            return {
              id: value,
              text: value
            }
          }

          $('.select2-search__field').css('color', '#dc3545')
          
          return null
        },
      })
    },
  }
</script>
